export const NAVIGATION_CONFIGURATION_STORAGE_KEY = "customSidebar";
export const NAVIGATION_DEFAULT_VIEW_STORAGE_KEY = "navigationDefaultView";
export const NAVIGATION_ITEMS_COUNT_LIMIT = 3;
